export default __webpack_public_path__ + "static/hero-fb876a71e1cd69f104d1e5ae6d112e04.png";